import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import HelpButton from './HelpButton'
import CommandPalette from './CommandPalette'

const Layout = ({ userRole = 'client', children }) => {
  const [collapsed, setCollapsed] = useState(false)
  const location = useLocation()

  // Check if current route is an editor (hide shell chrome for full-screen editors)
  const isEditorRoute =
    location.pathname.includes('/admin/editor') ||
    location.pathname.includes('/admin/neweditor') ||
    location.pathname.includes('/client/editor')

  return (
    <div className="app-shell">

      {/* Sidebar — hidden on editor routes */}
      {!isEditorRoute && (
        <Sidebar
          collapsed={collapsed}
          onCollapse={() => setCollapsed(c => !c)}
        />
      )}

      {/* Main area */}
      <div className="main-area">

        {/* Topbar — hidden on editor routes */}
        {!isEditorRoute && <Header />}

        {/* Page content */}
        {isEditorRoute ? (
          <div style={{ height: '100%' }}>
            {children || <Outlet />}
          </div>
        ) : (
          <div className="page-scroll">
            {children || <Outlet />}
          </div>
        )}

      </div>

      {/* Floating Help Button for Client Users */}
      {userRole === 'client' && !isEditorRoute && <HelpButton variant="floating" />}

      {/* Command Palette — always mounted, renders nothing when closed */}
      <CommandPalette />

    </div>
  )
}

export default Layout
